var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressLevel4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fba416;}.cls-2{fill:#964e1d;}.cls-3{fill:none;stroke:#964e1d;stroke-linecap:round;stroke-miterlimit:10;stroke-width:30px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.33,584.83A285,285,0,0,1,98.81,98.31,285,285,0,0,1,501.86,501.36,283.13,283.13,0,0,1,300.33,584.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.33,29.83a270.08,270.08,0,0,1,105.09,518.8A270.08,270.08,0,0,1,195.25,51,268.25,268.25,0,0,1,300.33,29.83m0-30c-165.68,0-300,134.32-300,300s134.32,300,300,300,300-134.31,300-300S466-.17,300.33-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.22,445.5c5-6.92,57.13-77,150-77,8.52,0,95.87,1.54,150,77"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 226.33,
    cy: 233.19,
    rx: 25,
    ry: 42.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 374.33,
    cy: 233.19,
    rx: 25,
    ry: 42.65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressLevel4);
export default __webpack_public_path__ + "static/media/stress_level_4.93250a2ff988ff7d3b9d70ea0c8a0f42.svg";
export { ForwardRef as ReactComponent };